import React from 'react';
import { incidentTypeNames } from 'src/api/types';
import { ScenarioPdfQuery } from 'src/graphql/_generated';
import { Image, Link, Text, View } from '@react-pdf/renderer';
import { pdfStyles } from '../pdfStyles';
import { getExternalPath } from '../util';
import { extLinkImg } from '../imgData';
import { ColorSet } from 'src/redux/reducers/theme';
import { formatDate } from 'src/utils/misc';
import { PdfLinkifyText } from './PdfLinkifyText';

type IncidentGql = NonNullable<ScenarioPdfQuery['scenario']>['incidents'][number];

interface IncidentsTableProps {
  data: IncidentGql[];
  colors: ColorSet;
}

export const IncidentsTable: React.FC<IncidentsTableProps> = ({ data, colors }) => {
  return (
    <>
      <View
        wrap={false}
        break={false}
        style={{
          height: 24,
          border: `1px solid ${colors.cflowerBlue}`,
          borderTopLeftRadius: 4,
          borderTopRightRadius: 4,
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        <View style={{ ...pdfStyles.tableCell, flex: 0.4 }}>
          <Text style={pdfStyles.tableHeader}>Reference</Text>
        </View>
        <View style={{ ...pdfStyles.tableCell, flex: 0.8 }}>
          <Text style={pdfStyles.tableHeader}>Name</Text>
        </View>
        <View style={{ ...pdfStyles.tableCell, flex: 0.4 }}>
          <Text style={pdfStyles.tableHeader}>Type</Text>
        </View>
        <View style={{ ...pdfStyles.tableCell, flex: 0.4 }}>
          <Text style={pdfStyles.tableHeader}>Severity</Text>
        </View>
        <View style={{ ...pdfStyles.tableCell, flex: 0.4 }}>
          <Text style={pdfStyles.tableHeader}>Owner</Text>
        </View>
        <View style={{ ...pdfStyles.tableCell, flex: 0.4 }}>
          <Text style={pdfStyles.tableHeader}>Date</Text>
        </View>
      </View>
      {data.map((el) => (
        <View
          key={el.id}
          wrap={false}
          break={false}
          style={{
            minHeight: 24,
            border: `1px solid ${colors.cflowerBlue}`,
            display: 'flex',
            flexDirection: 'row',
            marginTop: -1,
          }}
        >
          <View style={{ ...pdfStyles.tableCell, flex: 0.4 }}>
            <Text style={{ ...pdfStyles.tableValue }}>{el.ref || '-'}</Text>
          </View>
          <View style={{ ...pdfStyles.tableCell, flex: 0.8 }}>
            <Link
              src={getExternalPath(`incidents/${el.id}`)}
              style={{
                alignItems: 'center',
                justifyContent: 'flex-start',
                flexDirection: 'row',
                textDecoration: 'none',
              }}
            >
              <Text style={{ ...pdfStyles.tableValue, textDecoration: 'underline', marginRight: 6 }}>
                {el.name || '-'}
              </Text>
              {/* <Image src={extLinkImg} style={{ width: 8, height: 8 }} /> */}
            </Link>
          </View>
          <View style={{ ...pdfStyles.tableCell, flex: 0.4 }}>
            <Text style={pdfStyles.tableValue}>{el.incidentType || '-'}</Text>
          </View>
          <View style={{ ...pdfStyles.tableCell, flex: 0.4 }}>
            <PdfLinkifyText style={pdfStyles.tableValue}>{el.severity || '-'}</PdfLinkifyText>
          </View>
          <View style={{ ...pdfStyles.tableCell, flex: 0.4 }}>
            <Text style={pdfStyles.tableValueWrappable}>{el.owner?.text || '-'}</Text>
          </View>
          <View style={{ ...pdfStyles.tableCell, flex: 0.4 }}>
            <Text style={pdfStyles.tableValue}>{formatDate(el.dateOfIncident, { emptyValue: '-' })}</Text>
          </View>
        </View>
      ))}
    </>
  );
};
